import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-custom',
    templateUrl: '../../../custom/home/home.html',
    styleUrls: ['../../../custom/home/home.css'],
})
export class HomeCustomComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
